import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {MyDialogDataModel} from '../../../models/my-dialog-data.model';
import {EditModalService} from '../../../services/edit-modal.service';
import {ProductModel} from '../../../models/product.model';
import {MyPriceApprovalModeEnum} from '../../../enums/my-price-approval-mode.enum';
import {RPriceInfoModel} from '../../../models/r-price-info.model';
import {DecimalPipe} from '@angular/common';
import {RPriceInfoModalComponent} from '../r-price-info-modal/r-price-info-modal.component';
import {EditModalCustomPriceTableService} from '../../../services/edit-modal-custom-price-table.service';
import {ModalVisibilityService} from '../../../services/modal-visibility.service';
import {Subscription} from 'rxjs';
import {EditModalSectionBaseComponent} from '../edit-modal-section-base.component';
import {PriceInfoModel} from '../../../models/price-info.model';
import {ModalDynamicV3Service} from '../../../../../shared-modal-dynamic/services/modal-dynamic-v3-service.service';

@Component({
    selector: 'app-devices-table-viewer',
    templateUrl: './devices-table-viewer.component.html',
    styleUrls: ['./devices-table-viewer.component.scss']
})
export class DevicesTableViewerComponent extends EditModalSectionBaseComponent implements OnInit, OnDestroy  {


    @Input() usePriceApprovalMode = MyPriceApprovalModeEnum.DISABLED;
    public model: MyDialogDataModel;

    private modalVisibilitySub: Subscription;
    private rPriceInfoModalDialogRef: any;

    constructor(
        public editModalService: EditModalService,
        public editModalCustomPriceTableService: EditModalCustomPriceTableService,
        public modalVisibilityService: ModalVisibilityService,
        private modalDynamicV3Service: ModalDynamicV3Service
    ) {
        super(editModalService);
    }

    ngOnInit() {
        super.ngOnInit();
        this.model = this.editModalService.getDialogModel();
    }

    public isInternalUser() {
        return false;
    }

    public isSmartPrint(device: ProductModel): boolean {
        return device.printSmart;
    }

    public isActivePriceApprovalMode() {
        return this.usePriceApprovalMode === MyPriceApprovalModeEnum.ACTIVE;
    }

    private openRPricesInfoModal(rPriceInfos: RPriceInfoModel[], anchor: any) {

        if (!this.isActivePriceApprovalMode()) {
            return;
        }

        this.modalVisibilityService.announceCloseEditDialogModalsRequest('waranty openRPricesInfoModal');


        const deltaX = -92;
        const deltaY = 0;


        const msgRows = rPriceInfos.map(rPriceInfo => {
            const formattedRPrice = new DecimalPipe('de-DE').transform(+rPriceInfo.rPrice, '1.2-2');
            return formattedRPrice + ' € (' + rPriceInfo.rPriceIdentifier + ')';
        });


        // helps avoid to display dialog out of the screen
        const expectedDialogHeight = (rPriceInfos.length * 28) + 12;
        const marginBottom = 10;

        const windowHeight = window.innerHeight;
        const windowWidth = window.innerWidth;

        let top = Math.floor(+anchor.getBoundingClientRect().top) + deltaY;

        if (windowHeight - expectedDialogHeight < top) {
            top = windowHeight - (expectedDialogHeight + marginBottom);
        }

        const right = Math.floor(windowWidth - anchor.getBoundingClientRect().right) - deltaX;

        this.rPriceInfoModalDialogRef = this.modalDynamicV3Service
            .open(RPriceInfoModalComponent, {
                model: {
                    msgRows: msgRows,
                    top: top + 'px',
                    right: right + 'px',
                    showCloseBtn: false,
                    minHeight: 40,
                }
            });


        this.modalVisibilitySub = this.modalVisibilityService.closeProjectListPageModalsRequestAnnounced$.subscribe(_ => {

            if (this.rPriceInfoModalDialogRef) {
                this.rPriceInfoModalDialogRef.close();
                this.modalVisibilitySub.unsubscribe();
                this.rPriceInfoModalDialogRef = undefined;
                this.modalVisibilitySub = undefined;
            }
        });

    }





    public closeRPricesInfoModal() {
        if (this.rPriceInfoModalDialogRef) {
            this.rPriceInfoModalDialogRef.close();
            this.rPriceInfoModalDialogRef = undefined;
        }
    }

    public getFormattedPriceValue(priceInfo: PriceInfoModel) {
        let result  = '';
        if (priceInfo.selectedPrice) {
            if ( this.isSelectedPriceTypeEqualOtherPrice(priceInfo.selectedPrice)) {
                result = new DecimalPipe('de-DE').transform(+priceInfo.customPriceInfo.customPrice, '1.2-2') +  ' €';
            } else {
                const rPriceInfo = priceInfo.rPriceInfo.find( rPriceInfoItem => rPriceInfoItem.rPriceIdentifier === priceInfo.selectedPrice);
                const price = rPriceInfo && rPriceInfo.rPrice;
                result = new DecimalPipe('de-DE').transform(+price, '1.2-2') +  ' € (' + priceInfo.selectedPrice + ')';

            }
        }

        return result;

    }

    public isSelectedPriceTypeEqualOtherPrice(priceLevel: string): boolean {
        return this.editModalCustomPriceTableService.isSelectedPriceTypeEqualOtherPrice(priceLevel);
    }

    public isColorPrinter(printer: ProductModel ):boolean {
        return this.editModalService.containerUtilsService.isColorPrinter(printer);
    }

    public priceNoteShouldBeVisible(priceType: string): boolean {
        return this.editModalCustomPriceTableService.priceNoteShouldBeVisible(priceType);
    }


    public ngOnDestroy(): void {
        if (this.modalVisibilitySub) {
            this.modalVisibilitySub.unsubscribe();
        }
    }
}
